<template>
    <div>
        <b-card header-tag="header" footer-tag="footer" :style="this.mode == 'comp' && 'height: auto' ">  
             <template v-if="!noHeader" v-slot:header>
                 <div class="headerLeft" style="margin: 1rem;" >
                    <router-link v-if="addUrl" class="btn hl-element btn-success" variant="success" tag="a" :to="'/'+addUrl"> 
                       {{$t('general.add')}}
                    </router-link>
                    <b-button v-if="eventBtn" class="btn hl-element btn-success" @click="eventBtn.clicked">{{eventBtn.text}}</b-button>
                    <b-button class="hl-element" v-b-modal.fields variant="primary">{{$t('general.headers')}}</b-button>
                    <b-button v-if="type == 'Service'" to="/Dealer/ServiceMaps" class="hl-element" variant="warning">Harita</b-button>
                    <b-button class="hl-element" v-if="inputs && search" v-b-modal.filterModal variant="info">{{$t('general.filter')}}</b-button>
                 </div>
                  <div class="headerRight">
                    <template v-if="setLimit">
                        <b-form-select v-model="limit" class="mb-3" @change="setLimit(limit)">
                            <b-form-select-option :value="10">10 {{$t('general.units')}}</b-form-select-option>
                            <b-form-select-option :value="25">25 {{$t('general.units')}}</b-form-select-option>
                            <b-form-select-option :value="50">50 {{$t('general.units')}}</b-form-select-option>
                            <b-form-select-option :value="100">100 {{$t('general.units')}}</b-form-select-option>
                            <b-form-select-option :value="250">250 {{$t('general.units')}}</b-form-select-option>
                            <b-form-select-option :value="500">500 {{$t('general.units')}}</b-form-select-option>
                            <b-form-select-option :value="1000">1000 {{$t('general.units')}}</b-form-select-option>
                        </b-form-select>
                        <b-form-input v-if="gSearch" :placeholder="$t('general.search')" v-model="s" @keyup.enter="gSearch(s)"></b-form-input>

                    </template>
                 </div>
            </template>
                 
            <b-modal id="fields" :title="$t('general.tableHeaders')" size="lg" hide-footer >
                <b-form-group :label="$t('general.viewHeaders')">
                    <b-form-checkbox-group id="tableField" v-model="filtered" name="tableField">
                        <b-form-checkbox v-for="field in fields" :key="field.key" :value="field.key" checked>{{field.label}}</b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-modal> 

             <b-modal id="filterModal" :title="$t('general.search')" size="lg" :cancel-title="$t('general.cancel')" :ok-title="$t('general.filter')" @ok="search">
                <b-form-group :label="$t('general.filterMsg')" >
                        <div class="filterInputs" v-for="input in inputs" :key="'filter-'+input.key">
                            <b-form-checkbox class="filterChck" style="" v-model="input.checked">
                                {{input.label}}
                            </b-form-checkbox>
                            <Datetime  class="filterInput" v-if="input.type == 'Date'"  v-model="input.val" :disabled="!input.checked"></Datetime>
                            <b-form-select v-else-if="input.type == 'Select'" class="filterInput" v-model="input.val" :disabled="!input.checked">
                                <b-form-select-option v-for="item in input.array" :key="item.value" :value="item.value">{{item.text}}</b-form-select-option>
                            </b-form-select>
                            <b-form-input class="filterInput" v-else :placeholder="input.label" v-model="input.val" :disabled="!input.checked"></b-form-input>
                        </div>
                </b-form-group>

            </b-modal> 

            <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
                                  
            <b-table-simple v-else hover responsive @click="closeMenu">
                <draggable v-model="fields" tag="thead">
                    <b-th v-for="field in fields" :key="field.key">
                        <div v-if="filtered.includes(field.key)">
                            {{field.label}}
                        </div>
                    </b-th>
                </draggable>
                <b-tbody >
                    
                    <b-tr @contextmenu="openMenu($event, item)" @click="closeMenu" v-for="item in items" :key="item.id" @dblclick="goDetail(item)" :style="'color:'+item.fontColor+'; background:'+item.backColor" v-b-popover.hover="rowPopoverConfig(item)" > <!-- v-b-popover.hover="popoverConfig(item.note)" -->
                        <b-td v-for="field in fields" :key="field.key"> 
                            <div v-if="filtered.includes(field.key)">
                                <div v-if="field.key == 'note'">
                                    <span v-for=" note in item[field.key]" :key="note.index"> {{ note }} </span>
                                </div>
                                <div v-else-if="field.key == 'active'">
                                   <div v-if="item[field.key] == 0" > <b-badge variant="warning"  > {{ $t('account.suspend') }} </b-badge></div>
                                    <div v-if="item[field.key] == 1" > <b-badge variant="success" > {{ $t('account.active') }} </b-badge> </div>
                                    <div v-if="item[field.key] == 2" > <b-badge variant="danger" > {{ $t('account.cancel') }} </b-badge> </div>                    
                                </div>
                                 <div v-else-if="field.key == 'is_active'">
                                   <div v-if="item[field.key] == false" > <b-badge variant="danger" > {{ $t('account.cancel') }} </b-badge> </div>
                                    <div v-if="item[field.key] == true" > <b-badge variant="success" > {{ $t('account.active') }} </b-badge> </div> 
                                </div>
                                 <div v-else-if="field.key == 'is_approve'">
                                   <div v-if="renderData(field.keys, item) == false" >  <b-badge variant="danger" > {{$t('customer.approvement.unapproved')}} </b-badge> </div>
                                    <div v-if="renderData(field.keys, item) == true" > <b-badge variant="success" > {{$t('customer.approvement.approved')}}  </b-badge> </div> 
                                </div>
                                <div v-else-if="field.key == 'status_icon'">
                                   <div v-if="renderData(field.keys, item) == false" > <b-icon icon="x" variant="danger" animation="throb"></b-icon>  </div>
                                    <div v-if="renderData(field.keys, item) == true" > <b-icon icon="check" variant="success"></b-icon> </div> 
                                </div>
                                <div v-else-if="field.key == 'status_badge'">
                                   <div v-if="renderData(field.keys, item) == 'open'" >  <b-badge variant="danger" > Açık </b-badge>  </div>
                                   <div v-else-if="renderData(field.keys, item) == 1" >  <b-badge variant="danger" > Açık </b-badge>  </div>
                                   <div v-else>  <b-badge variant="success" > Kapalı </b-badge>  </div>
                                </div>
                                <div v-else-if="field.key == 'subscribes'"> 
                                    <span v-for="(sub,index) in item[field.keys[0]]" :key="sub.id"> 
                                        <b-badge  :id="'sub'+sub.key" :variant="variants[index%7]"> {{sub.sub.name}} </b-badge> 
                                        <b-tooltip v-if="sub.users" :target="'sub'+sub.key" triggers="click">
                                            <ul class="others" >
                                                <li v-for="user in sub.users" :key="user.id">{{user}}</li>
                                            </ul>
                                        </b-tooltip>
                                    </span>
                                </div>
                                <div v-else-if="field.key == 'actions'">
                                     <b-dropdown variant="default">
                                        <template slot="button-content"> <b-icon :title="field.label" icon="three-dots"  scale="1.25" shift-v="1.25" aria-hidden="true" /> </template>                                  
                                        <b-dropdown-item 
                                            v-for="action in actions"
                                            :key="action.key"
                                            @click="actionEvent(action.key, item )"
                                            :disabled=" 
                                            action.state !== undefined && action.state == item['active'] || 
                                            action.state !== undefined && action.state == item['is_active'] || 
                                            action.approve !== undefined && action.approve == item['is_approve']"> 
                                            {{action.text}}
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                                <div v-else-if="field.key == 'address'"> 
                                    {{ item[field.key].address +" "+ item[field.key].town.name + " / " + item[field.key].city.name + " / " + item[field.key].country.name}}
                                </div>
                                <span v-else-if="field.type == 'date'">{{ dateFormat(renderData(field.keys, item))}}</span>
                                <span v-else-if="field.type == 'dateTime'">{{ dateTimeFormat(renderData(field.keys, item))}}</span>
                                <span v-else-if="field.type == 'expiredIn'">
                                    <b-badge :variant="expiredIn(renderData(field.keys, item)) < 0 ? 'danger':'info'" v-b-popover.hover="popoverConfig(renderData(field.keys, item))">
                                        <span v-if="expiredIn(renderData(field.keys, item)) < 0">{{$t('general.expired')}}</span>
                                        <span v-else>{{expiredIn(renderData(field.keys, item))}} {{$t('general.expiredIn')}}</span>
                                    </b-badge>
                                </span>
                                <div v-else-if="field.type == 'badge'">
                                   <div  >  <b-badge :variant="getVariant(field.keys, item)" > {{renderData(field.keys, item)}} </b-badge>  </div>
                                </div>
                                <div v-else-if="field.type == 'data'">
                                    <template v-if="renderData([...field.keys[0]], item).id !== undefined ? renderData([...field.keys[0]], item).id > 0 : true">
                                        <div v-if="field.data[renderData(field.keys, item)].text" > 
                                            <b-badge :variant="field.data[renderData(field.keys, item)].variant">
                                                {{field.data[renderData(field.keys, item)].text}}
                                            </b-badge>
                                        </div>
                                        <div v-else >  {{field.data[renderData(field.keys, item)]}} </div>
                                    </template>
                               
                                </div>
                                <div v-else-if="field.type == 'multiple'">
                                   <div>  {{renderMultipleData(field.keys, item)}} </div>
                                </div>
                                <div v-else-if="field.type == 'multipleBadge'">
                                   <div v-if="renderData(field.keys[0], item) == 'open'" >  <b-badge variant="danger" > Açık </b-badge>  </div>
                                   <div v-else-if="renderData(field.keys[0], item) == 'closed'">  
                                    <b-badge variant="success" > Kapalı </b-badge> 
                                    <b-badge variant="dark" > {{renderData(field.keys[1], item)}} </b-badge> 
                                 </div>
                                </div>
                                <span v-else>{{ renderData(field.keys, item)}}</span>
                            </div>    
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <span v-if="type === 'Accounts'" class="detailText"> <a href="#"> {{ $t('general.seeAll') }} </a> </span>
            <ul id="right-click-menu" tabindex="-1" ref="right" v-if="viewMenu && rightMenus.length > 0" :style="'top:'+top+'; left:'+left+';'">
                <li v-for="rm in rightMenus" :key="rm.key" @click="rightMenuClick(rm)">{{ rm.text }}</li>
            </ul>
            <template v-slot:footer v-if="pageData">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="pageData.count"
                    :per-page="pageData.limit"
                ></b-pagination>
            </template>
        </b-card>
       
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import i18n from '../plugins/i18n';
    import moment from 'moment'
    import { Datetime } from 'vue-datetime';

    export default {
        name: "Table",
        components: {
            draggable, Datetime
        },
        watch:{
            currentPage(val){
                this.setPage(val)
            }
        },
        data: () => {
            return {
                 signalType: "signals",
                 viewMenu: false,
                 lastItem: {},
                 signalTypes: [
                    { text: 'Sadece Alarmlar', value: 'alarm' },
                    { text: 'Tüm Sinyaller', value: 'signals' },
                ],
                currentPage: 1,
                variants: [  'primary', 'success', 'danger', 'dark', 'warning', 'default', 'info'],
                s:""
            }
        },
        props:{
            fields: Array,
            items: Array,
            filtered: Array,
            type: String,
            mode: String,
            addUrl: String,
            loading: Boolean,
            limit: Number,
            page: Number,
            setLimit: Function,
            setPage: Function,
            actions: Array,
            actionEvent: Function,
            pageData: Object,
            goDetail: Function,
            inputs: Array, 
            search: Function,
            gSearch: Function,
            eventBtn: Object,
            noHeader: Boolean,
            rightMenus: Array,
            rmClick: Function,
            popover: Array
        },
        methods:{
            // kayıt a sağ tıklanınca açılan menünün konumlarını belirler.
            setMenu: function(top, left) {
                this.top = top + 'px';
                this.left = left + 'px';
            },
            // kayıta  sağ tıklayınca açılan menünün kapanmasını sağlar
            closeMenu: function() {
                this.viewMenu = false;
            },
            // kayıt a sağ  tıklayınca menünün açılmasını sağlar
            openMenu: function(e, item) {
                if(this.rightMenus){
                     this.closeMenu();
                    this.viewMenu = true;
                    this.setMenu(e.pageY, e.pageX)
                    this.lastItem = item
                    e.preventDefault();
                }  
            },
            rightMenuClick: function(rm){
                this.closeMenu()
                this.rmClick(rm.key, this.lastItem)
            },
            renderData: function(data, obj){
                let detail;
                if(data){
                   for(let i = 0; i<data.length; i++){

                        detail = detail ? detail[data[i]] : obj[data[i]]
                    }
                    return detail 
                }
                
            },

            renderMultipleData: function(data, obj){
                let detail;
                let text = '';
                let tmpData = [...data];
                if(data.length > 0){
                    if( obj.type == 'in' || obj.type == 'fault-in'){
                        tmpData = tmpData.reverse()
                    }
                   for(let i = 0; i<tmpData.length; i++){
                        for(let k = 0; k < tmpData[i].length; k++){
                            detail = detail ? detail[tmpData[i][k]] : obj[tmpData[i][k]]
                        }
                        if(detail)
                            text = text == '' ? detail : text+ ' -> ' + detail
                        detail = null
                    }
                }
                 return text 
            },
            dateFormat(val){
                return moment(String(val)).format('DD.MM.YYYY') 
            },
            
            dateTimeFormat(val){
                return moment(String(val)).format('DD.MM.YYYY HH:mm') 
            },
            expiredIn(val) {
                const today = moment()
                const expDate = moment(val.split('T')[0])
                return expDate.diff(today, 'days') + 1
            },
            getVariant(field, item){
                let variants = ['primary','success','danger','info','warning','dark']
                let i = item[field[0]].id ? item[field[0]].id : item[field[0]].ID ? item[field[0]].ID : 1
                if(field[0] == 'customer_sub')
                    i = item[field[0]].subscription_id

                return variants[i%6]
            },
            popoverConfig(data) {
                    return {
                        html: true,
                        placement: 'bottom',
                        customClass: 'popover',
                        content: () => {
                            const date = this.dateFormat(data)
                            const content = `<strong>${i18n.t('general.endDate')}: </strong>${date.split(' ')[0]}`
                            return content
                        },
                    }
                },
            rowPopoverConfig(data) {
                return {
                    html: true,
                    placement: 'bottom',
                    customClass: 'popover',
                    content: () => {
                        if (this.popover){
                            let content = ""
                            this.popover.forEach(field => {
                                content += `
                                <strong>${field.label}: </strong>
                                ${field.type == 'date' ? this.dateFormat(this.renderData(field.keys, data)) : 
                                this.renderData(field.keys, data)} 
                                <br />`
                            })
                            return content
                        }
                        return 
                        
                    },
                }
            }
        }
    }

</script>

<style lang="css" scoped>
    @import "./styles/table.min.css";
</style>



// WEBPACK FOOTER //
// src/components/Table.vue